<template>
	<pop-up-wrapper>
		<div class="pop-up-share-student-credentials">
			<img @click="close" class="close" src="/img/close.svg" alt="" />
			<p class="title">Identifiants élèves</p>
			<table v-if="students.length !== 0">
				<thead>
					<tr>
						<th>Nom</th>
						<th>Identifiant</th>
						<th>Code</th>
					</tr>
				</thead>

				<tbody>
					<Row v-for="student in students" :key="student.id" :student="student"/>
				</tbody>
			</table>
			<div v-else class="btn-container">
				<router-link 
					class="submit go-to-add-student"
					:to="{
						name:'ClassStudent',
						params: { id: classId },
					}"
				>
					Ajouter ses élèves
				</router-link>
			</div>
		</div>
	</pop-up-wrapper>
</template>
<script>
import { allStudentsInClasseService } from '../../../services/studentsService'
import PopUpWrapper from '../PopUpWrapper.vue'
import Row from './PopUpShareStudentCredentials/Row.vue'
import { decrypt } from '../../../utils/utils'

export default{
	components:{ PopUpWrapper, Row },
	props:{
		id: String
	},
	data(){
		return{
			students: []
		}
	},
	computed: {
		classId(){
			return decrypt(this.$route.params.classId)
		}
	},
	methods:{
		close(){ 
			this.$emit('close')
		},
		async getStudents(){
			const res = await allStudentsInClasseService(this.id)
			this.students = res
		}
	},	
	created(){
		this.getStudents()
	}
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/pop-up/pop-up-share-student-credentials.scss';
</style>
